import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { Auth } from '@angular/fire/auth';
import { onAuthStateChanged } from 'firebase/auth';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  constructor(private auth: Auth, private router: Router) {

    onAuthStateChanged(this.auth, (user) => {
      if (user && this.router.url === '/') {
        this.router.navigateByUrl('/dashboard');
      }
    });

  }
}